import { render, staticRenderFns } from "./appDrawerMenu.vue?vue&type=template&id=f219e9b8"
import script from "./appDrawerMenu.vue?vue&type=script&lang=js"
export * from "./appDrawerMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports